<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Relatório de Pagamentos
                </h2>
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto">
                <div class="py-4 grid grid-cols-5 gap-4 ">
                    <div class="col-span-2" v-if="$page.props.user.scope === 'admin'">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Ver como:
                        </label>

                        <div class="inline-flex rounded-md shadow-sm" role="group">
                            <button type="button" class="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-l-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': view !== 'admin'}" @click="view = 'admin'">
                                Admin
                            </button>
                            <button type="button" class="py-2 px-4 text-sm font-medium text-gray-900 bg-white rounded-r-md border border-gray-200 hover:bg-gray-100 hover:text-gray-700" :class="{'bg-gray-300': view !== 'other'}" @click="view = 'other'">
                                Cliente
                            </button>
                        </div>
                    </div>
                    <div class="col-span-3">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Clientes
                        </label>
                        <jet-auto-complete
                            id="contact" class="mt-1 block w-full"
                            :endpoint="'customers'"
                            :auto-load="true"
                            :custom-option="customCustomerView"
                            @input="reloadTransactions"
                            v-model="customerSelect"
                        />
                    </div>
                </div>

                <div class="bg-white shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000"/>
                    <inertia-table
                        :icon="null"
                        :data="payments"
                        :enableSearch="false"
                        :columns="columns[view]"
                        :filters="filters"
                        :params="params"
                        id="id"
                        table-classes="text-xs"
                        routeName="acquiring.payments"
                        >

                        <template slot-scope="row" slot="account_holder">
                            {{ row.item.account_holder.name || '' }}
                            <div class="text-xs text-gray-500" v-if="row.item.acquirer && row.item.acquirer.name">
                                {{ row.item.acquirer.name }}
                            </div>
                        </template>

                        <template slot-scope="row" slot="acquirer">
                            {{ row.item.acquirer.name || '' }}
                        </template>

                        <template slot-scope="row" slot="release_date">
                            <span class="text-center">
                                {{ row.item.release_date | smallDate }}
                            </span>
                        </template>

                        <template slot-scope="row" slot="total_amount">
                            <span class="text-right">
                                {{ row.item.total_amount | currency }}
                            </span>
                        </template>

                         <template slot-scope="row" slot="adiq_amount">
                            <span class="text-right">
                                {{ row.item.adiq_amount | currency }}
                            </span>
                        </template>

                         <template slot-scope="row" slot="adiq_amount">
                            <span class="text-right">
                                {{ row.item.adiq_amount | currency }}
                            </span>
                        </template>

                         <template slot-scope="row" slot="sub_amount">
                            <span class="text-right">
                                {{ row.item.sub_amount | currency }}
                            </span>
                        </template>

                         <template slot-scope="row" slot="cac_amount">
                            <span class="text-right">
                                {{ row.item.cac_amount | currency }}
                            </span>
                        </template>

                         <template slot-scope="row" slot="over_amount">
                            <span class="text-right">
                                {{ row.item.over_amount | currency }}
                            </span>
                        </template>

                        <template slot-scope="row" slot="total_fee_amount">
                            <span class="text-right">
                                {{ row.item.total_fee_amount | currency }}
                            </span>
                        </template>

                        <template slot-scope="row" slot="canceled_amount">
                            <span class="text-right">
                                {{ row.item.canceled_amount | currency }}
                            </span>
                        </template>

                        <template slot-scope="row" slot="pending_amount">
                            <span class="text-right">
                                {{ row.item.pending_amount | currency }}
                            </span>
                        </template>

                        <template slot-scope="row" slot="net_value">
                            <span class="text-right">
                                {{ row.item.net_value | currency }}
                            </span>
                        </template>

                        <template slot-scope="row" slot="status">
                            <div class="text-center" >
                                {{ getStatus(row.item.status) }}
                            </div>
                        </template>

                    </inertia-table>
                </div>
            </div>
        </div>

        <Jet-dialog-modal :show="modalSelect" >
            <template #title>
                Selecione um cliente
            </template>
            <template #content>
                <div class="grid grid-cols-12 gap-4 ">
                    <div class="col-span-12">
                        <label class="block text-gray-700 text-sm font-bold mb-2">
                            Clientes
                        </label>
                        <jet-auto-complete
                            id="contact" class="mt-1 block w-full z-40"
                            :endpoint="'customers'"
                            :auto-load="true"
                            :custom-option="customCustomerView"
                            @input="reloadTransactions"
                            v-model="customerSelect"
                        />
                    </div>
                </div>
            </template>
             <template #footer>
                <jet-secondary-button @click.native="modalSelect = false">
                    Cancelar
                </jet-secondary-button>
            </template>
        </Jet-dialog-modal>


    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';
import TgoWidget from '../../Helpers/Widget';
import JetConfirmationModal from './../../Jetstream//ConfirmationModal';
import JetDialogModal from './../../Jetstream/DialogModal'
import JetSecondaryButton from './../../Jetstream/SecondaryButton'
import moment from 'moment/dist/moment';

export default {
    components: {
        JetSecondaryButton,
        JetDialogModal,
        JetConfirmationModal,
        TgoWidget,
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable
    },
    props: ['payments','customer'],
    data() {
        return {
            modalSelect: false,
            view: this.$page.props.user.scope === 'admin' ? 'admin' : 'other',
            columns: {
                admin: [
                    {text: 'Descrição', className: 'text-left', key: 'description', sortable: false},
                    {text: 'Estabelecimento/Adq', className: 'text-left', key: 'account_holder', sortable: false},
                    {text: 'Bruto', className: 'text-left', key: 'total_amount', sortable: false},
                    {text: 'Adiq', className: 'text-left', key: 'adiq_amount', sortable: false},
                    {text: 'Sub', className: 'text-left', key: 'sub_amount', sortable: false},
                    {text: 'UN', className: 'text-left', key: 'cac_amount', sortable: false},
                    {text: 'Over', className: 'text-left', key: 'over_amount', sortable: false},
                    {text: 'Taxa total', className: 'text-left', key: 'total_fee_amount', sortable: false},
                    {text: 'Cancelado', className: 'text-left', key: 'canceled_amount', sortable: false},
                    {text: 'Pag. pendente', className: 'text-left', key: 'pending_amount', sortable: false},
                    {text: 'Valor líquido', className: 'text-left', key: 'net_value', sortable: false},
                    {text: 'Status', className: 'text-left', key: 'status', sortable: false},
                    {text: 'Data de pagamento', className: 'text-center', key: 'release_date', sortable: true},
                ],
                other: [
                    {text: 'Descrição', className: 'text-left', key: 'description', sortable: false},
                    {text: 'Estabelecimento/Adquirente', className: 'text-left', key: 'account_holder', sortable: false},
                    {text: 'Bruto', className: 'text-left', key: 'total_amount', sortable: false},
                    {text: 'Taxa', className: 'text-left', key: 'total_fee_amount', sortable: false},
                    {text: 'Cancelado', className: 'text-left', key: 'canceled_amount', sortable: false},
                    {text: 'Pag. pendente', className: 'text-left', key: 'pending_amount', sortable: false},
                    {text: 'Valor líquido', className: 'text-left', key: 'net_value', sortable: false},
                    {text: 'Status', className: 'text-left', key: 'status', sortable: false},
                    {text: 'Data de pagamento', className: 'text-center', key: 'release_date', sortable: true},
                ],
            },
            status: [
                { id: 'error', name: 'Erro' },
                { id: 'pending', name: 'Pendente' },
                { id: 'paid', name: 'Pago' },
                { id: 'canceled', name: 'Cancelado' },
                { id: 'refunded', name: 'Devolvido' },
            ],
            params: {
                sort: 'release_date:desc',
                page: 1,
                ...this.$page.props.queryString
            },
            filters: [
                {
                    text: 'Período por data de transação',
                    key: 'date',
                    type: 'date_interval',
                    colSpan: 3,
                },
                {
                    text: 'Data por',
                    key: 'date_field',
                    type: 'dropdown',
                    colSpan: 1,
                    options: [
                        { id: 'created', name: 'Data de fechamento' },
                        { id: 'release_date', name: 'Data de pagamento' },
                    ],
                },
                {
                    text: 'Status',
                    key: 'status',
                    type: 'dropdown',
                    colSpan: 1,
                    options: [
                        { id: 'pending', name: 'Pendente' },
                        { id: 'paid', name: 'Pago' },
                        { id: 'canceled', name: 'Cancelado' },
                        { id: 'refunded', name: 'Devolvido' },
                    ],
                },
                {
                    text: 'Adquirente',
                    key: 'acquirer_id',
                    type: 'dropdown',
                    colSpan: 1,
                    options: [
                        { id: 'pagseguro', name: 'Pag Seguro' },
                        { id: 'quero2pay', name: 'Quero 2 Pay' },
                        { id: 'bmp', name: 'BMP' },
                        { id: 'other', name: 'Outros' },
                    ],
                },
            ],
            scopes: {
                reseller: 'Revendedor',
                seller: 'Vendedor',
                holder: 'Estabelecimento',
                admin: 'Admin',
                partner: 'Parceiro',
                customer: 'Cliente',
                employee: 'Colaborador',
            },
            customerSelect:{}
        }
    },
    methods: {
        getStatus(status){
            switch (status) {
                case 'error':
                    return 'Erro'
                case 'pending':
                    return 'Pendente'
                case 'paid':
                    return 'Pago'
                case 'canceled':
                    return 'Cancelado'
                case 'refunded':
                    return 'Devolvido'
                default:
                    return 'Erro'
            }
        },
        reloadTransactions(e){
            if(e && e.id){
                this.$inertia.get(this.route('acquiring.payments', {'customer_id':e.id}));
            }else{
                this.$inertia.get(this.route('acquiring.payments',{'clear':true}));
            }
        },
        customCustomerView(option) {

            let name = option.name || 'Sem nome';
            let scopes = option.scope || [];

            scopes = scopes.map(scope => this.scopes[scope]).join(', ');

            return `
                <div class="flex items-center">
                    <div class="ml-3">
                        <div class="text-xs leading-none font-medium text-gray-900">${name}</div>
                        <div class="text-xs leading-none text-gray-500">${scopes}</div>
                    </div>
                </div>
            `;

        },
    },
    created() {
        if(!this.customer){
            this.modalSelect = true;
        }else{
            this.customerSelect = this.customer;
        }
    },
}


</script>
